export default [
  {
    title: '任务ID',
    key: 'taskId',
    width: 72
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 84
  },
  {
    title: '游戏',
    key: 'gameName',
    width: 140,
    overflow: true
  },
  {
    title: '计划组',
    key: 'campaignName',
    overflow: true,
    width: 164
  },
  {
    title: '转化名称',
    key: 'convertName',
    width: 200,
    overflow: true
  },
  {
    title: '计划名称',
    key: 'planName',
    width: 200,
    overflow: true
  },
  {
    title: '创意名称',
    key: 'title',
    width: 164,
    overflow: true
  },
  {
    title: '智能化项目ID',
    key: 'intelligentProjectId',
    width: 90
  },
  {
    title: '状态',
    key: 'taskStatus',
    width: 160,
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: 140
  },
  {
    title: '提交人',
    key: 'opName',
    width: 90
  },
  {
    title: '提交时间',
    key: 'createTime',
    width: 130
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 130
  },
  {
    title: '操作',
    key: 'control',
    width: 116,
    fixed: 'right'
  }
]
